export default "__VITE_ASSET__BcJn$ezs__"